import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  getBrandAssets,
  getFormCollectionFields,
  getGoogleJwt,
  getApplePass,
  submitFormData,
} from '../utils/helpers';
import { BrandAssets, FormCollectionFields, FormData } from '../types';

export const useBrandAssets = (brandId: string | null) => {
  return useQuery<BrandAssets, Error>(
    ['brandAssets', brandId],
    () => getBrandAssets(brandId!),
    {
      enabled: !!brandId,
      retry: 2,
    }
  );
};

export const useFormCollectionFields = (brandId: string | null) => {
  return useQuery<FormCollectionFields, Error>(
    ['formCollectionFields', brandId],
    () => getFormCollectionFields(brandId!),
    {
      enabled: !!brandId,
      retry: 2,
    }
  );
};

export const useSubmitForm = () => {
  const queryClient = useQueryClient();

  return useMutation<{ id: string }, Error, { brandId: string; data: FormData }>(
    ({ brandId, data }) => submitFormData(brandId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['formCollectionFields']);
      },
    }
  );
};

export const useGoogleJwt = () => {
  return useMutation<string, Error, { brandId: string; formCollectionId?: string }>(
    ({ brandId, formCollectionId }) => getGoogleJwt(brandId, formCollectionId)
  );
};

export const useApplePass = () => {
  return useMutation<string, Error, { brandId: string; formCollectionId?: string }>(
    ({ brandId, formCollectionId }) => getApplePass(brandId, formCollectionId)
  );
};
